import AvailabilityList from "../containers/reservations/cruise/availability/AvailabilityList";

const routes = [
  {
    path: "/availabilityReport",
    component: AvailabilityList,
  },
  
];

export { routes as availabilityRoutes };
